module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "16px"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.data.recipes) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.data.recipes), function(recipe, index) {
    return _c('mu-col', {
      key: 'r' + index,
      staticClass: "bottom",
      attrs: {
        "width": "100",
        "desktop": "33",
        "tablet": "33"
      }
    }, [_c('recipe-card', {
      attrs: {
        "recipe": recipe
      }
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "detector"
  }), _vm._v(" "), (_vm.isAppending) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n      "), _c('div', {
    staticStyle: {
      "height": "16px"
    }
  }), _vm._v(" "), _c('mu-circular-progress')], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f653d3a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Category.vue
// module id = 3870
// module chunks = 1